import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router";

import Layout from "layout";

import Home from "pages/Home";
import Sphere from "pages/Sphere";
import Statistic from "pages/Statistic";
import Organization from "pages/Organization";
import FunctionView from "pages/FunctionView";
import FunctionRegister from "pages/FunctionRegister";
import ServiceRegister from "pages/ServiceRegister";
import ServiceRegisterList from "pages/ServiceRegisterList";
import ServiceView from "pages/ServiceView";
import ServiceStats from "pages/ServiceStats";
import MandatoryRequirement from "./pages/MandatoryRequirement";
import MandatoryRequirementRegister from "./pages/MandatoryRequirementRegister";
import MandatoryRequirementView from "./pages/MandatoryRequirementView";
import AISearch from "pages/AISearch";
import AIPairsSearch from "pages/AIPairsSearch";
import Oked from "pages/Oked";
import OrganizationStats from "pages/OrganizationStats";
import ServiceOrganizations from "pages/ServiceOrganizations";
import AIRequirementsSearch from "pages/AIRequirementsSearch";
import AIRequirementsPairsSearch from "pages/AIRequirementsPairsSearch";
import FunctionNames from "pages/FunctionNames";
import FunctionNameOrganizations from "pages/FunctionNameOrganizations";
import FunctionTaskOrganizations from "pages/FunctionTaskOrganizations";
import FunctionTasks from "pages/FunctionTasks";

import AOS from 'aos';
import 'aos/dist/aos.css';

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-out-cubic',
      once: true
    });
  }, []);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/spheres" element={<Sphere />} />

        <Route path="/organizations" element={<Organization />} />

        <Route path="/function-register" element={<FunctionRegister />} />
        <Route path="/function-register/view/:id" element={<FunctionView />} />

        <Route path="/function-name-organizations" element={<FunctionNameOrganizations />} />
        <Route path="/function-names" element={<FunctionNames />} />

        <Route path="/function-task-organizations" element={<FunctionTaskOrganizations />} />
        <Route path="/function-tasks" element={<FunctionTasks />} />

        <Route path="/service-register" element={<ServiceRegister />} />
        <Route path="/service-register/list" element={<ServiceRegisterList />} />
        <Route path="/service-register/stats" element={<ServiceStats />} />
        <Route path="/service-register/view/:id" element={<ServiceView />} />

        <Route path="/mandatory-requirement" element={<MandatoryRequirement />} />
        <Route path="/mandatory-requirement/register" element={<MandatoryRequirementRegister />} />
        <Route path="/mandatory-requirement/view/:id" element={<MandatoryRequirementView />} />

        <Route path="/oked" element={<Oked />} />
        <Route path="/organization-stats" element={<OrganizationStats />} />
        <Route path="/service-organizations" element={<ServiceOrganizations />} />


        <Route path="/ai-search" element={<AISearch />} />
        <Route path="/ai-pairs-search" element={<AIPairsSearch />} />

        <Route path="/ai-requirements-search" element={<AIRequirementsSearch />} />
        <Route path="/ai-requirements-pairs-search" element={<AIRequirementsPairsSearch />} />

        <Route path="/statistics" element={<Statistic />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  )
};

export default App;
